<div
  class="flex flex-col justify-between lg:flex-nowrap flex-wrap gap-6 w-[100%] mx-auto px-7 py-6 bg-white/[.95] rounded-lg shadow-sm border border-solid border-gray-100">
  <div class="w-full relative z-0 flex justify-start items-center gap-3 !duration-300">
   
    <div #hotel routerLink="" routerLinkActive="activeAccomodation" 
     [routerLinkActiveOptions]="{exact: true}"
      (click)="changeAccommodation('hotel', hotel.clientWidth)"
      
      class="cursor-pointer hover:!bg-slate-200 transition-colors duration-200 rounded-full flex justify-start gap-3 px-3 items-center ">
      <span>
        <i class="mr-2 ico-Building text-lg"></i>
      </span>
      <span class="!font-semibold text-base">هتل</span>
    </div>
    <div #ecolodge routerLink="/ecolodge" routerLinkActive="activeAccomodation"
    
      [routerLinkActiveOptions]="{exact: true}" (click)="changeAccommodation('ecolodge', ecolodge.clientWidth)"
      class="relative cursor-pointer hover:!bg-slate-200 transition-colors duration-200 rounded-full flex justify-start gap-3 px-3 items-center group">
    
      <span>
        <i class="ico-Ecotourism-line text-lg"></i>
      </span>
      <span class="!font-semibold text-base ">ویلا
        و
        اقامتگاه</span>
    </div>
    <div class="w-full h-[1px] bg-gray-100 rounded-lg absolute -bottom-2 !duration-300 shadow-inner">
      <div [style.right.px]="activeAccomodationNavigator().position"
        [style.width.px]="activeAccomodationNavigator().width"
        class="contents[''] bg-blue-500 h-[2px] absolute bottom-0 right-0 rounded-lg !shadow-2xl !shadow-red-800 !duration-300">
      </div>
    </div>
  </div>
  <div
    class="flex justify-between lg:flex-nowrap flex-wrap gap-2 w-[725px] lg:w-[100%] mx-auto p-1 bg-white/[.95] rounded-2xl">
    <div class="iho-autocomplete w-[100%] lg:w-[40%]">
      <div class="relative" ihoAutocomplete>
        <mat-form-field appearance="outline" class="w-full density-settings-0">
          <mat-label class="!font-medium text-black-500 mr-2">
            {{searchBoxService.accommodation() == 'ecolodge' || searchBoxService.accommodation() == 'villa-mashhad'  ? 'جستجوی شهر، منطقه یا ویلا' : 'مقصد یا هتل'}}
          </mat-label>
          <input matInput class="!font-bold" id="input-search"
          autocomplete="off"
            [value]="autocompleteService._selectedItem().name !== undefined ? autocompleteService._selectedItem().name : ''">
          <mat-icon matPrefix>
            <i class="mr-2 ico-Location text-2xl text-gray-500"></i>
          </mat-icon>
          <small *ngIf="autocompleteValidate" class="text-nowrap text-red-400 absolute -bottom-[24px] -right-[48px]">
            لطفا مقصد خود را انتخاب نمایید
          </small>
        </mat-form-field>
      </div>
      <iho-autocomplete />
    </div>
    <div class="iho-datepicker w-[100%] lg:w-[40%]">
      <div ihoDatepicker class="flex gap-2">
        <mat-form-field appearance="outline" class="w-full m-0 p-0 density-settings-0">
          <mat-label class="!font-medium text-black-500 mr-2">
            تاریخ ورود
          </mat-label>
          <input matInput class="!font-bold" readonly autocomplete="off" id="input-startDate"
            [value]="datepickerService._customStartDate()">
          <mat-icon matPrefix>
            <i class="mr-2 ico-Calender text-2xl text-gray-500"></i>
          </mat-icon>
          <small *ngIf="startDateValidate" class="text-nowrap text-red-400 absolute -bottom-[24px] -right-[48px]">
            لطفا تاریخ ورود را انتخاب نمایید
          </small>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full m-0 p-0 density-settings-0" disabled>
          <mat-label class="!font-medium text-black-500 mr-2">
            تاریخ خروج
          </mat-label>
          <input matInput class="!font-bold" readonly autocomplete="off" id="input-endDate"
            [value]="datepickerService._customEndDate()">
          <mat-icon matPrefix>
            <i class="mr-2 ico-Calender text-2xl text-gray-500"></i>
          </mat-icon>
          <small *ngIf="endDateValidate" class="text-nowrap text-red-400 absolute -bottom-[24px] -right-[48px]">
            لطفا تاریخ خروج را انتخاب نمایید
          </small>
        </mat-form-field>
      </div>
      <ng-container *ngComponentOutlet="csrStatus()"></ng-container>
    </div>
    <div class="w-[100%] lg:w-[20%]">
      <button (click)="search()" id="btn-search"
        class="w-full h-[56px] bg-blue-500 rounded-lg text-md text-white md:text-xl hover:bg-blue-600 duration-100 transition-all mr-2">
        جستجو
      </button>
    </div>
  </div>
</div>